module.exports = __webpack_public_path__ + "img/tender_icon.5d7d9f77.svg";